import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const ApproveIcon = (props) => <FontAwesomeIcon icon={["fas", "thumbs-up"]} {...props}/>

export default ApproveIcon;

